import WidgetPicker from './widget-picker.component';
export default WidgetPicker;
